module.exports = __webpack_public_path__ + "img/video-poster.b1518e8f.png";